export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { opacity: 1, scale: 1 },
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const revealTransition = { duration: 0.55, ease: EASE_OUT } as const;

// Preset spread-abili sui motion.* delle pagine pubbliche.
export const sectionReveal = {
  initial: 'hidden',
  whileInView: 'visible',
  viewport: { once: true, amount: 0.25 },
  variants: fadeInUp,
  transition: revealTransition,
} as const;

export const listReveal = {
  initial: 'hidden',
  whileInView: 'visible',
  viewport: { once: true, amount: 0.2 },
  variants: staggerContainer,
} as const;
